module.exports = __webpack_public_path__ + "379881e4ddb5db3856e7499d05af1a7b.png";